<button
  type="button"
  class="flex h-10 w-46 cursor-pointer items-center gap-2 rounded-lg border border-white/45 bg-white/10 pl-3 pr-1.5 text-sm font-medium text-on-primary transition-colors hover:bg-white/20 focus-visible:outline focus-visible:outline-offset-2"
  [matMenuTriggerFor]="localeMenu"
  [attr.aria-label]="'nav.locale-filter' | translate">
  <img class="h-auto w-[22px] rounded-[2px] align-middle ring-1 ring-black/15" [src]="localeSwitcher.current().flag" alt="" />
  <span class="flex-1 truncate text-left">{{ localeSwitcher.current().country }}</span>
  <mat-icon class="shrink-0">arrow_drop_down</mat-icon>
</button>

<mat-menu #localeMenu="matMenu" class="w-46 max-w-none">
  @for (locale of localeSwitcher.locales; track locale.code) {
    <button
      mat-menu-item
      [disabled]="locale.code === localeSwitcher.selectedLocaleCode()"
      (click)="localeSwitcher.setLocale(locale.code)">
      <span class="flex items-center gap-3">
        <img class="h-auto w-[22px] rounded-[2px] align-middle ring-1 ring-black/15" [src]="locale.flag" alt="" />
        <span>{{ locale.country }}</span>
      </span>
    </button>
  }
</mat-menu>
